
const pageWard = (page: string) => {
    if (localStorage.getItem("page") === page) {
        return true;
    } else {
        localStorage.setItem("page", "");
        return false;
    }
}

export {pageWard};